import * as yup from 'yup';
import i18next from 'i18next';

// Valid type values for dadeviation/init endpoint
const VALID_DEVIATION_TYPES = [
  'art',
  'journal',
  'commission',
  'status-update',
  'poll',
  'tier',
] as const;

function getDaDeviationInitValidationSchema() {
  return yup.object({
    deviationid: yup
      .number()
      .integer(i18next.t('validation.daDeviationInit.deviationId.integer'))
      .required(i18next.t('validation.daDeviationInit.deviationId.required')),
    username: yup
      .string()
      .required(i18next.t('validation.daDeviationInit.username.required')),
    comments_cursor: yup.string().optional(),
    type: yup
      .string()
      .oneOf(
        VALID_DEVIATION_TYPES as any,
        i18next.t('validation.daDeviationInit.type.oneOf', {
          types: VALID_DEVIATION_TYPES.join(', '),
        })
      )
      .required(i18next.t('validation.daDeviationInit.type.required'))
      .test(
        'type-not-empty',
        i18next.t('validation.daDeviationInit.type.notEmpty'),
        value => {
          return value !== undefined && value !== null && value !== '';
        }
      ),
    preload: yup.boolean().optional(),
    current_id: yup.number().integer().optional(),
    include_session: yup.boolean().optional(),
  });
}

/**
 * Validates dadeviation/init request data using Yup schema
 * Based on papiRequestDaDeviationInitSchema
 * @param data The request data to validate
 * @returns boolean indicating if validation passed
 */
export function validateDaDeviationInitRequest(data: any): boolean {
  try {
    getDaDeviationInitValidationSchema().validateSync(data, {
      abortEarly: false,
    });
    return true;
  } catch (error) {
    return false;
  }
}
